import { ReactElement } from 'react';
import { EIconSize } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';

const SPORTS_MENU_SKELETON_COUNT = 5;

export const SportsMenuSkeleton = (): ReactElement => {
  return (
    <>
      {createArray(SPORTS_MENU_SKELETON_COUNT).map(key => (
        <div key={key} className="sportsMenu__item">
          <Skeleton.Avatar size={EIconSize._24} active />
          <Skeleton
            title={{ style: { height: 8, width: 45, margin: '5px 0 0' } }}
            paragraph={false}
            active
          />
        </div>
      ))}
    </>
  );
};
